import type { MouseEventHandler } from 'react';

export type ButtonLinkType = 'default' | 'outline';

type ButtonLink = {
  type: ButtonLinkType;
  text: string;
  url: string;
  linkInNewWindow: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const ButtonLink = ({
  type = 'default',
  text,
  url,
  linkInNewWindow,
  className,
  onClick,
}: ButtonLink) => {
  return (
    <a
      href={url}
      onClick={onClick}
      target={linkInNewWindow ? '_blank' : '_self'}
      className={`flex items-center justify-center min-w-72 px-2 py-3 no-underline underline-offset-2 hover:underline ${type === 'outline' ? 'border-2 border-black' : 'bg-black text-white border-2 border-black'} ${className || ''}`}
    >
      {text}
    </a>
  );
};

export default ButtonLink;
